/* ============================================================================
 * BUSCADOR INTELIGENTE MOTIONFLUID (predictivo + tolerante a errores)
 * ----------------------------------------------------------------------------
 * Mismo motor del buscador de Cohynsa, AUTO-CONTENIDO y con la piel de Motion:
 *   - Inyecta su propio CSS (paleta azul→cian, redondeado, sombra premium).
 *   - Crea su propio panel de resultados anclado bajo la barra de búsqueda del
 *     header (la que se expande con la lupa: input[type=search][name=q]).
 *   - Índice cliente de TODOS los productos (/products.json), cacheado en
 *     sessionStorage (TTL 15 min) y precargado al primer foco.
 *   - Match difuso: sin acentos, prefijo, subcadena, SKU, marca/tipo y
 *     DISTANCIA DE EDICIÓN (Levenshtein) para tolerar errores de dedo
 *     ("mangera" → manguera, "conexon" → conexión).
 *   - Panel con foto + título + marca·tipo + precio; teclado (↑↓ Enter Esc);
 *     fila degradada "Ver todos los resultados" → búsqueda nativa.
 * ========================================================================== */
(function () {
  'use strict';
  if (window.__smartSearch) return;
  window.__smartSearch = true;

  /* ======================= CONFIGURACIÓN ======================= */
  var CONFIG = {
    // caja(s) de búsqueda del tema (evita inputs ocultos de facetas)
    inputSelector: 'input[type="search"], input[name="q"]:not([type="hidden"])',
    accent: '#0093e9',                 // azul Motionfluid
    accent2: '#2bc4f0',                // cian Motionfluid (degradados)
    ink: '#0d3c6e',                    // azul marino para texto de marca/acento oscuro
    maxResults: 7,
    debounceMs: 110,
    cacheKey: 'ss_index_v2',           // v2: nuevo formato de índice (bt/tg). Súbelo para forzar recarga
    cacheTtlMs: 15 * 60 * 1000,
  };
  /* ============================================================= */

  /* ---------- normalización ---------- */
  function norm(s) {
    return String(s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')   // quita acentos
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* ---------- Levenshtein acotado (con corte para velocidad) ---------- */
  function lev(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    if (la === 0) return lb; if (lb === 0) return la;
    var prev = new Array(lb + 1), cur = new Array(lb + 1), i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur[0] = i; var best = cur[0];
      for (j = 1; j <= lb; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      var tmp = prev; prev = cur; cur = tmp;
    }
    return prev[lb];
  }

  /* ---------- índice de productos ---------- */
  var INDEX = null, loading = null;

  function fromCache() {
    try {
      var o = JSON.parse(sessionStorage.getItem(CONFIG.cacheKey) || 'null');
      if (!o || (Date.now() - o.t) > CONFIG.cacheTtlMs || !Array.isArray(o.d)) return null;
      return o.d;
    } catch (e) { return null; }
  }
  function toCache(d) { try { sessionStorage.setItem(CONFIG.cacheKey, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }
  function thumb(src) { return src ? src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=96' : ''; }

  function buildRecord(p) {
    var vs = p.variants || [], skus = [], minP = null, avail = false, i;
    for (i = 0; i < vs.length; i++) {
      if (vs[i].sku) skus.push(vs[i].sku);
      var pr = parseFloat(vs[i].price);
      if (!isNaN(pr) && (minP === null || pr < minP)) minP = pr;
      if (vs[i].available) avail = true;
    }
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
    var img = (p.images && p.images[0]) ? p.images[0].src : (p.image ? p.image.src : '');
    var nt = norm(p.title);
    return {
      t: p.title, h: p.handle, v: p.vendor || '', ty: p.product_type || '',
      img: thumb(img), p: minP, av: avail, vc: vs.length,
      cot: tags.some(function (t) { return /cotiza/i.test(t); }),
      nt: nt, w: nt.split(' ').filter(Boolean), sk: skus.map(norm),
      bt: norm([p.vendor, p.product_type].join(' ')),   // marca + tipo (coincidencia SÓLIDA)
      tg: norm(tags.join(' ')),                          // tags (coincidencia DÉBIL, no ancla)
    };
  }

  function loadIndex() {
    if (INDEX) return Promise.resolve(INDEX);
    if (loading) return loading;
    var cached = fromCache();
    if (cached) { INDEX = cached; return Promise.resolve(INDEX); }
    loading = (function () {
      var all = [];
      function page(n) {
        return fetch('/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (j) {
            var ps = (j && j.products) || [], i;
            for (i = 0; i < ps.length; i++) all.push(buildRecord(ps[i]));
            if (ps.length === 250 && n < 8) return page(n + 1);
          });
      }
      return page(1).then(function () { INDEX = all; toCache(all); loading = null; return INDEX; })
        .catch(function () { loading = null; return (INDEX = INDEX || []); });
    })();
    return loading;
  }

  /* ---------- puntuación difusa ---------- */
  function maxDist(len) { return len <= 4 ? 1 : (len <= 7 ? 2 : 3); }

  // Devuelve { s: puntaje, solid: true si la coincidencia es de TÍTULO/palabra/SKU/marca-tipo
  // (ancla real) y false si es sólo substring de título, tag o fuzzy flojo. El "solid" evita
  // que basura entre por un tag: ej. "5 mall" no debe traer conexiones que sólo tienen el tag
  // "conexion-mallas" — su "mall" es tag (débil), mientras la manguera lo tiene como palabra.
  function tokenScore(tok, rec) {
    var i, w;
    if (rec.nt.indexOf(tok) === 0) return { s: 34, solid: true };   // el título empieza con el token
    var best = 0;
    for (i = 0; i < rec.w.length; i++) {                            // palabra del título (1ª pesa más)
      w = rec.w[i];
      if (w === tok) best = Math.max(best, i === 0 ? 32 : 26);
      else if (w.indexOf(tok) === 0) best = Math.max(best, i === 0 ? 28 : 21);
    }
    if (best) return { s: best, solid: true };
    for (i = 0; i < rec.sk.length; i++) if (rec.sk[i].indexOf(tok) === 0) return { s: 26, solid: true };  // SKU
    var bt = rec.bt || '', tg = rec.tg || '';
    if (bt.indexOf(tok) >= 0) return { s: 14, solid: true };        // marca / tipo (búsqueda legítima)
    if (rec.nt.indexOf(tok) >= 0) return { s: 15, solid: false };   // substring a media palabra: débil
    if (tg.indexOf(tok) >= 0) return { s: 7, solid: false };        // tag: débil, no ancla
    if (tok.length >= 3) {                                          // typos
      var md = maxDist(tok.length), b = md + 1, bi = -1;
      for (i = 0; i < rec.w.length; i++) {
        w = rec.w[i]; if (Math.abs(w.length - tok.length) > md) continue;
        var d = lev(tok, w, md); if (d < b) { b = d; bi = i; } if (b === 1) break;
      }
      if (b <= md) { var base = Math.max(4, 13 - b * 3); return { s: bi === 0 ? base + 9 : base, solid: true }; }  // typo en palabra del título = sólido
      var hw = (bt + ' ' + tg).split(' '), b2 = md + 1;
      for (i = 0; i < hw.length; i++) {
        w = hw[i]; if (!w || Math.abs(w.length - tok.length) > md) continue;
        var d2 = lev(tok, w, md); if (d2 < b2) b2 = d2; if (b2 === 1) break;
      }
      if (b2 <= md) return { s: Math.max(3, 10 - b2 * 3), solid: false };
    }
    return { s: 0, solid: false };
  }

  function search(q, limit) {
    var qn = norm(q); if (!qn || !INDEX) return [];
    var toks = qn.split(' ').filter(Boolean), multi = toks.length > 1, res = [], i, k;
    for (i = 0; i < INDEX.length; i++) {
      var rec = INDEX[i], sc = 0, all = true, solid = 0;
      for (k = 0; k < toks.length; k++) {
        var m = tokenScore(toks[k], rec);
        if (m.s <= 0) { all = false; break; }
        if (m.solid) solid++;
        sc += m.s;
      }
      if (!all) continue;
      if (multi && solid === 0) continue;   // 2+ palabras: exige al menos una coincidencia sólida (no sólo tags)
      if (rec.nt.indexOf(qn) === 0) sc += 45; else if (rec.nt.indexOf(qn) >= 0) sc += 22;
      if (rec.av) sc += 3;
      res.push({ r: rec, s: sc });
    }
    res.sort(function (a, b) { return b.s !== a.s ? b.s - a.s : a.r.t.length - b.r.t.length; });
    return res.slice(0, limit || CONFIG.maxResults).map(function (x) { return x.r; });
  }

  /* ---------- render ---------- */
  function money(n) { return '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function isEn() { return (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0; }

  function render(panel, q, list, loadingState) {
    if (loadingState) { panel.innerHTML = '<div class="ss-state">' + (isEn() ? 'Searching…' : 'Buscando…') + '</div>'; panel.style.display = 'block'; return; }
    var html = '';
    if (!list.length) {
      html = '<div class="ss-state">' + (isEn() ? 'No results for ' : 'Sin resultados para ') + '<b>“' + esc(q) + '”</b>.<br>' +
        '<span>' + (isEn() ? 'Try the brand, the type, or check the spelling.' : 'Prueba con la marca, el tipo o revisa la ortografía.') + '</span></div>';
    } else {
      html = '<ul class="ss-list">';
      for (var i = 0; i < list.length; i++) {
        var r = list[i], meta = [r.v, r.ty].filter(Boolean).join(' · ');
        var price = r.cot ? '<span class="ss-cot">' + (isEn() ? 'Quote' : 'Cotizar') + '</span>'
                  : (r.p != null && r.p > 0 ? '<span class="ss-price">' + (r.vc > 1 ? (isEn() ? 'From ' : 'Desde ') : '') + money(r.p) + '</span>' : '');
        html += '<li class="ss-item"><a href="/products/' + esc(r.h) + '">' +
          (r.img ? '<img class="ss-img" src="' + esc(r.img) + '" alt="" loading="lazy">' : '<span class="ss-img ss-noimg"></span>') +
          '<span class="ss-tx"><span class="ss-t">' + esc(r.t) + '</span>' +
          (meta ? '<span class="ss-meta">' + esc(meta) + '</span>' : '') + '</span>' + price + '</a></li>';
      }
      html += '</ul>';
    }
    html += '<a class="ss-all" href="/search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last">' +
      (isEn() ? 'See all results for ' : 'Ver todos los resultados de ') + '“' + esc(q) + '” <span>→</span></a>';
    panel.innerHTML = html;
    panel.style.display = 'block';
  }

  /* ---------- CSS auto-inyectado (piel Motionfluid) ---------- */
  function injectCSS() {
    if (document.getElementById('ss-css')) return;
    var a = CONFIG.accent, a2 = CONFIG.accent2, ink = CONFIG.ink;
    var css = [
      '.ss-panel{position:fixed;z-index:100000;background:#fff;border-radius:20px;',
      'box-shadow:0 24px 54px -14px rgba(0,147,233,.30),0 10px 26px -12px rgba(13,60,110,.18);',
      'border:1px solid rgba(0,147,233,.16);max-height:min(72vh,480px);overflow-y:auto;display:none;',
      "font-family:'Montserrat','Roboto',var(--font-body-family),system-ui,-apple-system,sans-serif;-webkit-overflow-scrolling:touch}",
      '.ss-panel::-webkit-scrollbar{width:8px}.ss-panel::-webkit-scrollbar-thumb{background:rgba(0,147,233,.28);border-radius:999px}',
      '.ss-list{list-style:none;margin:0;padding:7px}',
      '.ss-item a{display:flex;align-items:center;gap:13px;padding:10px 11px;border-radius:14px;text-decoration:none;color:#16273c;transition:background .15s ease}',
      '.ss-item a:hover,.ss-item.ss-sel a{background:linear-gradient(90deg,rgba(0,147,233,.08),rgba(43,196,240,.08))}',
      '.ss-img{width:50px;height:50px;flex:0 0 auto;border-radius:11px;object-fit:contain;background:#fff;border:1px solid #e8eef4;padding:3px;mix-blend-mode:multiply}',
      '.ss-noimg{background:#eef3f8;mix-blend-mode:normal}',
      '.ss-tx{min-width:0;flex:1;display:flex;flex-direction:column;gap:3px}',
      '.ss-t{font-size:13.5px;font-weight:600;line-height:1.32;color:#16273c;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.ss-meta{font-size:11.5px;font-weight:500;color:#7c93ab;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.ss-price{flex:0 0 auto;font-size:13.5px;font-weight:800;color:' + a + ';white-space:nowrap}',
      '.ss-cot{flex:0 0 auto;font-size:11px;font-weight:800;color:' + a + ';border:1.5px solid ' + a + ';border-radius:999px;padding:3px 10px;text-transform:uppercase;letter-spacing:.03em}',
      '.ss-all{display:flex;align-items:center;justify-content:center;gap:8px;padding:13px;margin-top:2px;',
      'background:linear-gradient(135deg,' + a + ',' + a2 + ');color:#fff;font-size:12.5px;font-weight:800;',
      'text-decoration:none;text-transform:uppercase;letter-spacing:.05em;border-radius:0 0 20px 20px;transition:filter .15s ease}',
      '.ss-all:hover{filter:brightness(1.06)}.ss-all span{font-size:15px;transition:transform .15s ease}.ss-all:hover span{transform:translateX(4px)}',
      '.ss-state{padding:26px 20px;text-align:center;color:' + ink + ';font-size:13.5px;line-height:1.55}',
      '.ss-state b{color:#16273c}.ss-state span{display:block;margin-top:5px;font-size:12px;color:#9aa9ba}',
      /* ---- página de resultados /search (takeover): cuadrícula estilo Motion ---- */
      '.ssr-wrap{max-width:1200px;margin:0 auto;padding:6px 16px 64px}',
      '.ssr-head{font-family:inherit;font-size:1.15rem;font-weight:800;color:' + ink + ';margin:6px 4px 20px;letter-spacing:-.01em}',
      '.ssr-head b{color:' + a + '}',
      '.ssr-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:18px}',
      '.ssr-card{display:flex;flex-direction:column;background:#fff;border:1px solid #e8eef4;border-radius:18px;padding:14px;text-decoration:none;',
      'box-shadow:0 10px 26px -18px rgba(13,60,110,.35);transition:transform .2s ease,box-shadow .2s ease,border-color .2s ease}',
      '.ssr-card:hover{transform:translateY(-4px);border-color:rgba(0,147,233,.5);box-shadow:0 20px 40px -20px rgba(0,147,233,.35)}',
      '.ssr-card img,.ssr-noimg{width:100%;aspect-ratio:1;object-fit:contain;background:#fff;border-radius:12px;margin-bottom:12px;mix-blend-mode:multiply}',
      '.ssr-noimg{background:#eef3f8;mix-blend-mode:normal}',
      '.ssr-ct{font-size:13.5px;font-weight:600;line-height:1.34;color:#16273c;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;margin-bottom:4px}',
      '.ssr-meta{font-size:11.5px;font-weight:500;color:#7c93ab;margin-bottom:8px;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden}',
      '.ssr-pr{margin-top:auto;font-size:15px;font-weight:800;color:' + a + '}',
      '.ssr-cot{margin-top:auto;align-self:flex-start;font-size:11px;font-weight:800;color:' + a + ';border:1.5px solid ' + a + ';border-radius:999px;padding:3px 12px;text-transform:uppercase;letter-spacing:.03em}',
      '.ssr-empty{text-align:center;padding:60px 20px;color:' + ink + ';font-size:1rem;line-height:1.6}',
      /* cuando tomamos la página de resultados, ocultamos TODO lo nativo (con !important
         para ganarle a los estilos/JS del tema que reabren el título con la cuenta vieja) */
      'html.ss-took-over body .search-results-title,html.ss-took-over body #ProductGridContainer,html.ss-took-over body #main-search-filters,html.ss-took-over body .template-search [role="status"]{display:none !important}',
      '@media (max-width:600px){.ssr-grid{grid-template-columns:repeat(2,1fr);gap:12px}.ssr-card{padding:11px;border-radius:15px}.ssr-ct{font-size:12.5px}.ssr-head{font-size:1rem}}',
      /* iOS: input de búsqueda ≥16px en móvil para que no haga zoom al enfocar */
      '@media (max-width:1099px){input[type="search"],input[name="q"]{font-size:16px !important}}'
    ].join('');
    var st = document.createElement('style'); st.id = 'ss-css'; st.textContent = css;
    document.head.appendChild(st);
  }

  /* ---------- conexión de cada input ---------- */
  function wire(input) {
    if (input.__ssWired) return; input.__ssWired = true;
    var panel = document.createElement('div'); panel.className = 'ss-panel';
    document.body.appendChild(panel);

    var timer = null, lastQ = '';
    function place() {
      var r = input.getBoundingClientRect();
      if (!r.width || r.bottom < 0) { panel.style.display = 'none'; return; }
      var w = Math.max(r.width, 300);                     // panel cómodo aunque la barra sea angosta
      var left = Math.min(r.left, window.innerWidth - w - 10);
      panel.style.top = (r.bottom + 8) + 'px';
      panel.style.left = Math.max(10, left) + 'px';
      panel.style.width = w + 'px';
    }
    function close() { panel.style.display = 'none'; panel.innerHTML = ''; }
    function moveSel(dir) {
      var items = [].slice.call(panel.querySelectorAll('.ss-item'));
      if (!items.length) return;
      var cur = panel.querySelector('.ss-item.ss-sel'), idx = items.indexOf(cur);
      if (cur) cur.classList.remove('ss-sel');
      idx = dir === 'down' ? (idx + 1) % items.length : (idx <= 0 ? items.length - 1 : idx - 1);
      items[idx].classList.add('ss-sel'); items[idx].scrollIntoView({ block: 'nearest' });
    }
    function run() {
      var q = input.value.trim(); lastQ = q;
      if (!q) { close(); return; }
      if (!INDEX) { render(panel, q, [], true); place();
        loadIndex().then(function () { if (input.value.trim() === lastQ) { render(panel, lastQ, search(lastQ), false); place(); } });
        return;
      }
      render(panel, q, search(q), false); place();
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, CONFIG.debounceMs); });
    input.addEventListener('focus', function () { loadIndex(); if (input.value.trim()) run(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); moveSel('down'); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); moveSel('up'); }
      else if (e.key === 'Enter') { var sel = panel.querySelector('.ss-item.ss-sel a'); if (sel) { e.preventDefault(); location.href = sel.getAttribute('href'); } }
      else if (e.key === 'Escape') { close(); input.blur(); }
    });
    document.addEventListener('click', function (e) { if (e.target !== input && !panel.contains(e.target)) close(); });
    window.addEventListener('scroll', function () { if (panel.style.display === 'block') place(); }, true);
    window.addEventListener('resize', function () { if (panel.style.display === 'block') place(); });
  }

  /* ---------- takeover de la página de resultados /search ----------
   * La búsqueda NATIVA de Shopify devuelve resultados irrelevantes para este
   * catálogo (ej. "5 mall" → adaptadores/conexiones). Aquí, en la página de
   * resultados, reemplazamos la rejilla nativa por la de NUESTRO motor para
   * CUALQUIER consulta. Si el índice no cargó, se deja el nativo (no rompe). */
  function bigImg(u) { return u ? u.replace(/width=\d+/, 'width=440') : u; }

  function takeoverSearchPage() {
    if (!/(^|\/)search\/?$/.test(location.pathname)) return;
    var q = '';
    try { q = new URLSearchParams(location.search).get('q') || ''; } catch (e) { q = ''; }
    q = q.trim();
    if (!q) return;
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    loadIndex().then(function () {
      if (!INDEX || !INDEX.length) return;          // sin índice: deja el nativo intacto
      try {
        var list = search(q, 60);
        var host = document.createElement('div'); host.className = 'ssr-wrap';
        var n = list.length;
        var head = isEn()
          ? (n + ' result' + (n === 1 ? '' : 's') + ' for <b>“' + esc(q) + '”</b>')
          : (n + ' resultado' + (n === 1 ? '' : 's') + ' para <b>“' + esc(q) + '”</b>');
        var html = '<div class="ssr-head">' + head + '</div>';
        if (!n) {
          html += '<div class="ssr-empty">' + (isEn()
            ? 'No products matched. Try the brand, the type, or check the spelling.'
            : 'No encontramos productos. Prueba con la marca, el tipo o revisa la ortografía.') + '</div>';
        } else {
          html += '<div class="ssr-grid">';
          for (var i = 0; i < n; i++) {
            var r = list[i], meta = [r.v, r.ty].filter(Boolean).join(' · ');
            var price = r.cot ? '<span class="ssr-cot">' + (isEn() ? 'Quote' : 'Cotizar') + '</span>'
              : (r.p != null && r.p > 0 ? '<span class="ssr-pr">' + (r.vc > 1 ? (isEn() ? 'From ' : 'Desde ') : '') + money(r.p) + '</span>' : '');
            html += '<a class="ssr-card" href="/products/' + esc(r.h) + '">' +
              (r.img ? '<img src="' + esc(bigImg(r.img)) + '" alt="" loading="lazy">' : '<span class="ssr-noimg"></span>') +
              '<span class="ssr-ct">' + esc(r.t) + '</span>' +
              (meta ? '<span class="ssr-meta">' + esc(meta) + '</span>' : '') + price + '</a>';
          }
          html += '</div>';
        }
        host.innerHTML = html;
        container.parentNode.insertBefore(host, container);
        // Oculta TODO lo nativo (rejilla + filtros + título con la cuenta vieja) vía clase
        // raíz + CSS !important: robusto contra el JS del tema que reabre el título.
        document.documentElement.classList.add('ss-took-over');
        // Refuerzo: inline !important le gana a cualquier hoja de estilos del tema
        // (ej. .search-results-title lleva `display:block !important` en el tema).
        document.querySelectorAll('.search-results-title, #ProductGridContainer, #main-search-filters, .template-search [role="status"]').forEach(function (el) {
          el.style.setProperty('display', 'none', 'important');
        });
      } catch (e) { /* si algo falla, el nativo queda visible */ }
    });
  }

  function init() {
    injectCSS();
    takeoverSearchPage();
    var inputs = document.querySelectorAll(CONFIG.inputSelector);
    for (var i = 0; i < inputs.length; i++) wire(inputs[i]);
    // el input del header puede aparecer/ocultarse (barra que se expande): re-escanea
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var ins = document.querySelectorAll(CONFIG.inputSelector);
        for (var i = 0; i < ins.length; i++) if (!ins[i].__ssWired) wire(ins[i]);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(function () { loadIndex(); }, { timeout: 4000 });
    else setTimeout(loadIndex, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
